import React, { type FC } from "react";
import { sanitize } from "../utils/sanitizer";

type SanitizedRendererProps = {
    html: SanitizedString;
    as?: React.ElementType;
} & React.HTMLProps<HTMLDivElement>;

// eslint-disable-next-line id-length
const SanitizedRenderer: FC<SanitizedRendererProps> = ({ html = "", as = "span", ...props }) => {
    const Tag = as;
    return <Tag {...props} dangerouslySetInnerHTML={{ __html: html }} />;
};

export const UnsanitizedRenderer: FC<SanitizedRendererProps> = ({ html = "", ...props }) => {
    const sanitizedHtml = sanitize(html);
    return <SanitizedRenderer html={sanitizedHtml} {...props} />;
};

export default SanitizedRenderer;
